// src/components/OrganizationRankingsList.jsx
import { Box, Typography, Card, CardContent, Grid, Chip, Button, CardActions } from "@mui/material";
import RevaText from "components/common/RevaText";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { FormattedMessage } from "react-intl";
dayjs.locale("es");

export default function OrganizationRankingsList({ classifications = [] }) {
  if (!classifications.length) {
    return (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6">Esta organización no tiene classifications activos.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      <RevaText variant="h5" id="Rankings disponibles" />
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {classifications.map((ranking) => (
          <Grid item key={ranking.id} xs={12} sm={6} md={4}>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: 3,
                backgroundColor: "rgba(255,255,255,0.05)",
              }}
            >
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {ranking.name}
                </Typography>

                {ranking.description && (
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    {ranking.description}
                  </Typography>
                )}

                {ranking.category && <Chip label={ranking.category} size="small" color="primary" sx={{ mt: 1 }} />}
              </CardContent>
              <CardActions>
                {/* Si tenés una URL al detalle del ranking */}
                <Button href={`/rankings/${ranking.uuid_}`} size="small">
                  <FormattedMessage id="Ver ranking" />
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
